import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgSei = function SvgSei(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M59.705 119.72c32.974 0 59.705-26.8 59.705-59.86S92.68 0 59.705 0 0 26.8 0 59.86s26.73 59.86 59.705 59.86"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_2662_5730)",
        fillRule: "evenodd",
        d: "M59.555 119.718c17.737 0 33.673-7.714 44.634-19.971-5.099-4.432-12.783-4.701-18.211-.32l-1.037.836c-9.94 8.019-24.422 6.835-32.925-2.693-4.639-5.197-12.582-5.727-17.87-1.193l-11.956 10.25a59.6 59.6 0 0 0 37.365 13.091m19.408-28.985c9.467-7.64 22.773-7.365 31.878.013 5.442-9.018 8.573-19.586 8.573-30.887 0-12.556-3.865-24.21-10.473-33.834a14.17 14.17 0 0 0-12.38 3.257l-.997.884c-9.558 8.47-24.08 7.955-33.014-1.17-4.873-4.977-12.833-5.14-17.906-.368L30.73 41.718l-7.654-8.135 13.914-13.09c9.503-8.941 24.413-8.635 33.541.688 4.77 4.872 12.522 5.146 17.624.625l.998-.884a25.26 25.26 0 0 1 10.433-5.568C88.98 5.809 74.946 0 59.555 0 29.168 0 4.07 22.642.21 51.975c9.23-4.429 20.615-2.724 28.14 4.982a13.34 13.34 0 0 0 17.76 1.192l7.779-6.078c9.777-7.638 23.598-7.268 32.953.882l15.146 13.196-7.338 8.422-15.146-13.195a14.725 14.725 0 0 0-18.738-.502l-7.78 6.078c-9.845 7.691-23.9 6.748-32.628-2.19-5.075-5.198-13.377-5.38-18.675-.409L0 65.934c1.26 12.503 6.367 23.87 14.12 32.899l12.756-10.936c9.906-8.492 24.785-7.499 33.474 2.236 4.54 5.086 12.27 5.718 17.576 1.438z",
        clipRule: "evenodd"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_2662_5730",
        x1: 59.607,
        x2: 59.607,
        y1: 119.214,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B52A2A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#780000"
    })))));
};

export { SvgSei as ReactComponent };
//# sourceMappingURL=Sei.svg.es.js.map
